// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  cellaTrack: 'https://sgconv-cellatrackqa.cella.co.za/',
  cellaControlTowerApi: 'http://localhost:9931/',
  cellaGateway: 'https://gatewayqa.cella.co.za/',
  cellaClient: 'https://qa.cella.co.za/',
  production: false,
  tenant: 'SGCONV'
};
